import { SignatureEditorTab } from '@dealstack/frontend/shared/components/Signature/SignatureEditor/useSignatureEditor.types';

export const isSignatureEditorTab = (value: string | null): value is SignatureEditorTab =>
	value === SignatureEditorTab.DRAW ||
	value === SignatureEditorTab.TYPE ||
	value === SignatureEditorTab.UPLOAD;
